export const BookmarkIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2132_258)">
        <path
          d="M17 3H7C5.9 3 5 3.9 5 5V21L12 18L19 21V5C19 3.9 18.1 3 17 3ZM17 18L12 15.82L7 18V6C7 5.45 7.45 5 8 5H16C16.55 5 17 5.45 17 6V18Z"
          fill="#333333"
        />
      </g>
      <defs>
        <clipPath id="clip0_2132_258">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const SearchIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2132_265)">
        <path
          d="M18.0833 16.3333H17.1617L16.835 16.0183C18.235 14.385 18.9583 12.1567 18.5617 9.78833C18.0133 6.545 15.3067 3.955 12.04 3.55833C7.105 2.95166 2.95166 7.105 3.55833 12.04C3.955 15.3067 6.545 18.0133 9.78833 18.5617C12.1567 18.9583 14.385 18.235 16.0183 16.835L16.3333 17.1617V18.0833L21.2917 23.0417C21.77 23.52 22.5517 23.52 23.03 23.0417C23.5083 22.5633 23.5083 21.7817 23.03 21.3033L18.0833 16.3333ZM11.0833 16.3333C8.17833 16.3333 5.83333 13.9883 5.83333 11.0833C5.83333 8.17833 8.17833 5.83333 11.0833 5.83333C13.9883 5.83333 16.3333 8.17833 16.3333 11.0833C16.3333 13.9883 13.9883 16.3333 11.0833 16.3333Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_2132_265">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
